import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

export const SidebarHeader = ({ className, ...props }: ComponentProps<"div">) => (
  <div
    data-slot="sidebar-header"
    className={cn(
      "flex items-center justify-between gap-2 px-3 pt-4 group-data-[state=collapsed]/sidebar:flex-col group-data-[state=collapsed]/sidebar:gap-3.5 group-data-[state=collapsed]/sidebar:px-0",
      className,
    )}
    {...props}
  />
);
